import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { WhiteBadgeStyled } from '@/app/components/search/components/EvolutionCard/Badges/BaseBadge/styled.ts';

const ResortCreditBadge = () => {
  const { t } = useTranslation();
  return <WhiteBadgeStyled>{t('vacation.oss.cards.usp.resort_credits')}</WhiteBadgeStyled>;
};

export default ResortCreditBadge;
